import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const sharesTransferModalInitValue = {
  data: {
    operationType: '',
    modalLabels: {
      title: '',
      transmittingDate: '',
      transmittingPartner: '',
      transmittingSharesNumber: '',
      recipientPartner: '',
      addTransmit: '',
    },
    date: '',
    societyActualShares: 0,
    comments: '',
    file: undefined,
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    aliasOptions: [],
    scriptureView: true,
    selectedPartnerSellerOption: null,
    partnerSellerOptions: [],
    selectedPartnerBuyerOption: null,
    partnerBuyerOptions: [],
    selectedHoldingClass: '',
    holdingClassOptions: [],
    selectedHoldingClassOption: null,
    shareFrom: 0,
    shareTo: 0,
    validatedRanges: [],
    availableRanges: [],
    rangesPage: 1,
    rangesRowsPerPage: 10,
    totalAvailableRanges: 0,
    price: 0,
    selectedPriceTypeOption: null,
    priceTypeOptions: [],
    lastOperationDate: '',
    historyMovements: [],
    expandHistoryView: false,
    expandHistoryViewDirection: 'down',
    showAddPartnerSection: false,
    isValidRange: true,
    isValidatingRange: false,
    isLoadingAvailableRanges: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    onChangeNotaryName(): void {},
    onChangeNotaryProtocol(): void {},
    onChangeNotaryCity(): void {},
    handleChangeAlias(): void {},
    handleChangePartnerSeller(): void {},
    handleChangePartnerBuyer(): void {},
    handleSearchPartnerByTerm(): any {},
    handleChangeHoldingClass(): void {},
    handleFetchHoldingClassByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangeSharesToDecrease(): void {},
    handleChangeRangeFrom(): void {},
    handleChangeRangeTo(): void {},
    handleChangeShareFrom(): void {},
    handleValidateRange(): void {},
    handleChangeRangesPage(): void {},
    handleChangeRangesRowsPerPage(): void {},
    handleClickRange(): void {},
    handleChangeShareTo(): void {},
    handleChangePrice(): void {},
    handleChangePriceType(): void {},
    handleAddAllRanges(): void {},
    handleChangeExpandHistoryView(): void {},
    handleAddPartner(): void {},
    handleCloseAddPartnerSection(): void {},
    handleSaveMovement(): void {},
    handleSaveSharesTransfer(): void {},
  },
};
